import { Checkbox } from '@repo/videa-components/src/index';
import { Label } from '@repo/videa-components/src/ui/label';

interface Props {
  checked: boolean;
  id: string;
  label: string;
  onCheckedChange: (checked: boolean) => void;
}

export const CancelCheckbox = ({
  checked,
  id,
  label,
  onCheckedChange,
}: Props) => (
  <div className="vai-flex vai-items-center vai-gap-2">
    <Checkbox id={id} checked={checked} onCheckedChange={onCheckedChange} />
    <Label
      className="vai-font-inter vai-text-white vai-cursor-pointer"
      htmlFor={id}
    >
      {label}
    </Label>
  </div>
);
